import React from 'react'

import { IconProps } from '../Types'

export const Percentage = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="Percentage"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m8.64,19.88c-.16.27-.35.45-.58.53-.22.09-.44.11-.68.05-.22-.05-.4-.15-.56-.32-.16-.15-.25-.34-.28-.57-.03-.24.03-.5.19-.78L15.33,4.13c.16-.27.34-.46.56-.55.23-.09.46-.11.68-.05.22.05.4.15.56.32s.25.37.28.62c.05.23-.01.47-.16.73l-8.61,14.68Zm-2.49-6.32c-1.31,0-2.32-.44-3.05-1.33-.73-.89-1.1-2.09-1.1-3.62,0-1.02.16-1.9.49-2.63s.8-1.3,1.42-1.69,1.37-.6,2.24-.6c1.31,0,2.32.44,3.05,1.33.73.87,1.1,2.07,1.1,3.6,0,1.02-.16,1.91-.49,2.66-.33.73-.8,1.3-1.42,1.7-.62.38-1.37.58-2.24.58Zm0-1.93c.37,0,.69-.11.96-.32.26-.23.47-.56.61-1.01.14-.44.21-1.01.21-1.69,0-1.02-.16-1.78-.47-2.27-.32-.48-.75-.73-1.31-.73-.37,0-.69.11-.96.32s-.46.54-.6.99-.21,1-.21,1.69c0,1.04.16,1.8.47,2.29.3.49.74.73,1.3.73Zm11.7,8.66c-1.31,0-2.32-.44-3.05-1.33s-1.1-2.09-1.1-3.62c0-1.02.16-1.9.49-2.63.33-.73.8-1.3,1.42-1.7s1.37-.6,2.24-.6c1.31,0,2.32.44,3.05,1.33.73.87,1.1,2.07,1.1,3.6,0,1.02-.16,1.91-.49,2.66-.33.73-.8,1.3-1.42,1.69-.62.4-1.37.6-2.24.6Zm0-1.92c.37,0,.69-.11.96-.32.26-.21.47-.54.61-.98.14-.46.21-1.03.21-1.72,0-1.02-.16-1.78-.47-2.27s-.75-.73-1.31-.73c-.37,0-.69.11-.96.32-.26.21-.47.54-.61.98-.14.44-.21,1.01-.21,1.7,0,1.04.16,1.8.47,2.29.32.48.75.73,1.31.73Z"/>',
    }}
  />
)

Percentage.displayName = 'Percentage'

export const tags = ['Percentage', '']
